export const NOTIFY = {
    WITHDRAWAL_REQUEST_UPDATED: 'WITHDRAWAL_REQUEST_UPDATED',
    WITHDRAWAL_REQUEST_CREATED: 'WITHDRAWAL_REQUEST_CREATED',
    CHAT_MESSAGE: 'CHAT_MESSAGE',
    CHAT_MESSAGE_DELETED: 'CHAT_MESSAGE_DELETED',
    ARTIFACT_NEW: 'ARTIFACT_NEW',
    ARTIFACT_EMPTY: 'ARTIFACT_EMPTY',
    ARTIFACT_ERROR: 'ARTIFACT_ERROR',
};
